import * as React from 'react';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import styles from './styles.module.scss';
import './i18n';

export interface BreadcrumbItem {
  name: string;
  url?: string;
}

interface Props {
  items: BreadcrumbItem[];
  /** `dark`: white text over a photo or the navy band; `light`: for light backgrounds. */
  variant?: 'dark' | 'light';
}

/** "INICIO > ACCIONES > ...": the last item is the current page. */
const Breadcrumb = ({ items, variant = 'dark' }: Props) => (
  <nav aria-label={i18next.t('breadcrumb:label') as string} className={`${styles.breadcrumb} ${styles[variant]}`}>
    <ol>
      {items.map((item, index) => {
        const current = index === items.length - 1;
        return (
          <li key={`${index}-${item.name}`} className={current ? styles.current : undefined}>
            {item.url && !current
              ? <Link to={item.url}>{item.name}</Link>
              : <span aria-current={current ? 'page' : undefined}>{item.name}</span>}
          </li>
        );
      })}
    </ol>
  </nav>
);

export default Breadcrumb;
